import {Trans} from "ni18n";
import React from "react";
import {ImageItemList} from "src/components/_common/ImageItemList";
import {useCarbonForCampusConstants} from "src/constants/CarbonForCampus";

import {Btn} from "../V5Comp";

const About: React.FC = () => {
  const {imageItems, ctaProps} = useCarbonForCampusConstants();

  return (
    <div id="about" className="pv30 pb12-sm pt14-sm ph8">
      <div className="maxw80 ma">
        <div className="mb20">
          <h2 className="mb6 maxw52 fs40 fs28-sm">
            <Trans>
              <span className="darkerYellow">Carbon for Campus</span> redefines the student health
              clinic to provide for all of your diverse, vibrant student population's on-campus and
              remote healthcare needs.
            </Trans>
          </h2>
          <Btn {...ctaProps} className="focus-bsDarkBlue3" />
        </div>
        <ImageItemList itemClassName="maxw22" items={imageItems} rows={1} />
        <Btn {...ctaProps} className="focus-bsDarkBlue3 dn-f db-f-sm" />
      </div>
    </div>
  );
};

export default About;
